import CTA from '@/components/cta';

import { BackgroundColor } from '@/enums/background-color';
import useSpecialtyPageContext from '@/features/specialty-page/hooks/use-specialty-page-context';
import { routes } from '@/utils/route-utils';

export default function BrowseSpecialtyJobsCTA() {
  const { specialty } = useSpecialtyPageContext();

  return (
    <CTA
      title='See our highest paying travel nurse jobs'
      link={{
        href: routes.jobSearch({
          specialty: specialty?.title,
          discipline: specialty?.discipline?.apiId || undefined,
        }),
        children: 'Browse Jobs',
      }}
      full
      backgroundColor={BackgroundColor.PRIMARY_LIGHT}
    />
  );
}
